import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const FOOTER_LINKS = [
  { label: 'Privacy Policy', to: '/legal/privacy' },
  { label: 'Terms & Conditions', to: '/legal/terms' },
  { label: 'Cookie Policy', to: '/legal/cookies' },
  { label: 'Disclaimer', to: '/legal/disclaimer' },
];

const DISCLAIMER_TEXT =
  'The information provided on this website is for general guidance only and does not constitute legal advice. Specific legal advice should be obtained in relation to individual circumstances. Contacting us by email or telephone does not create a solicitor-client relationship until instructions have been formally accepted in writing. We do not accept responsibility for reliance placed on general information contained on this website without obtaining specific legal advice.';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Top section: brand + links */}
      <div className="footer__top">
        <div className="footer__brand">
          <span className="footer__brand-name">The LPA Company</span>
          <span className="footer__brand-tagline">
            LPA services, England &amp; Wales
          </span>
        </div>

        <div className="footer__links">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className="footer__link"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Divider */}
      <div className="footer__divider">
        <div className="footer__divider-line" />
      </div>

      {/* Disclaimer */}
      <div className="footer__bottom">
        <p className="footer__disclaimer">{DISCLAIMER_TEXT}</p>
        <p className="footer__copyright">
          &copy; {currentYear} The LPA Company (Lossos & Co. Limited). All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
